import { AbstractControl, ValidatorFn } from '@angular/forms';
import { SocialMediaHelper } from '@app/_shared/helpers/socialMediaHelper';

export function isSocialMedia(socialMediaHelper: SocialMediaHelper): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !socialMediaHelper.socialExist(control.value) && { isNotSocial: true }) || null;
}
